import axios from 'axios'
import { useUserStore } from '@/store/user/index.js'
import { showToast } from 'vant'
import { getI18n as i18n } from '@/locales/index'
let _axios = null
/**
 * 初始化
 */
export const baseURL = import.meta.env.VITE_APP_BASE_API
if (!_axios) {
  _axios = axios.create({
    // 默认请求连接
    baseURL: baseURL,
    // 请求头
    headers: {
      'Content-Type': 'application/json'
    },
    // 超时时间（ms）
    timeout: 60 * 1000
  })
}
// 匹配中文的正则
const chineseReg = /[\u4e00-\u9fa5]/
// 请求拦截器
_axios.interceptors.request.use((config) => {
  // 检查请求参数里是否有中文
  const hasChinese = (obj) => {
    if (!obj) return false
    if (typeof obj === 'string') return chineseReg.test(obj)
    if (typeof obj === 'object') {
      return Object.values(obj).some((v) => hasChinese(v))
    }
    return false
  }

  // if (hasChinese(config.params) || hasChinese(config.data)) {
  //   const { t } = i18n().global // 获取 t 函数
  //   showToast('不能输入中文')
  //   // 直接抛错，不让请求发出去
  //   return Promise.reject()
  // }
  // token 判断
  let userStore = useUserStore()
  let token = userStore.token

  if (token) {
    config.headers['satoken'] = token
  }
  config.headers['language'] = document.querySelector('html').getAttribute('language')
  config.headers['lang'] = document.querySelector('html').getAttribute('lang')
  return config
})

// 响应拦截器
_axios.interceptors.response.use((response) => {
  if (response.status === 200) {
    if (response.data.code == '500' && response.data?.msg?.includes('Token')) {
      // 判断钱包清除用户数据  浏览器 跳转登录页
      let userStore = useUserStore()
      userStore.signOut()
      setTimeout(() => location.reload(), 10)
    } else if (response.data.code == '401') {
      // 判断钱包清除用户数据  浏览器 跳转登录页
      let userStore = useUserStore()
      userStore.signOut()
      setTimeout(() => location.reload(), 10)
    }
    if (response.data && response.data.code > 0) {
      return Promise.resolve(response.data)
    } else {
      showToast(response.data.msg || 'System error')
      return Promise.reject(response)
    }
  } else {
    showToast('Network anomaly')
    return Promise.resolve(response)
  }
})

/**
 * post 请求
 */
export const post = (url, params) => _axios.post(url, params)

/**
 * get 请求
 */
export const get = (url, params) => _axios.get(url, { params })
